import script from "./AdminDashboardBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardBox.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AdminDashboardBox.vue?vue&type=style&index=1&id=3b289fb6&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b289fb6"]])

export default __exports__